import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface KonamiState {
  isUnlocked: boolean;
}

const initialState: KonamiState = {
  isUnlocked: false
};

export const konamiSlice = createSlice({
  name: 'konami',
  initialState,
  reducers: {
    setUnlocked: (state, action: PayloadAction<boolean>) => {
      state.isUnlocked = action.payload;
    },
    resetKonami: (state) => {
      state.isUnlocked = false;
    }
  }
});

// Actions exportieren
export const { setUnlocked, resetKonami } = konamiSlice.actions;

// Selektoren
export const selectIsKonamiUnlocked = (state: RootState) => state.konami.isUnlocked;

export default konamiSlice.reducer;
